export enum PrivateConfigurations {
  ORGANIZATION_UPDATES_LOCKED = 'organizationUpdatesLocked',
  GOALS_UPDATES_LOCKED = 'goalsUpdatesLocked',
  BENCHMARKS_MANAGEMENT = 'benchmarksManagement',
  ACTIVE_HOURS_MANAGEMENT = 'activeHoursManagement',
}
